import HomeBanner from "../component/Donation/HomeBanner";
import React, { useEffect, useState } from "react";
import axiosInstance from "../Axois/Axois";
import DonationCart from "../component/Donation/DonationCart";
import SectionFour from "../component/homecomponent/SectionFour";

const Donate = () => {
  // eslint-disable-next-line no-unused-vars
  const [entrepreneurDetails, setentrepreneurDetails] = useState([]);

  useEffect(() => {
    axiosInstance
      .get("/all/borrower")
      .then((res) => {
        setentrepreneurDetails(res?.data?.data);
        console.log(res, "borrower");
      })
      .catch((err) => { });
  }, []);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);



  return (
    <>
      <HomeBanner />
      <div className="container my-5">
        <h1 className="text-center my-2 fw-bold always-support-text-exact1 fst-normal fs-1">Donate</h1>

        <p className="col-8 d-block m-auto text-center">
          A donation from you will change many lives. It goes way beyond helping the first person or project that you donate to. As their 0% loans are repaid, your money is re-used, going to other needy entrepreneurs and projects on a similar 0% interest and repayment basis.
        </p>

        <div className="row justify-content-center align-items-center my-3">
          <h1 className="text-center pt-4 fw-bold text-dark  my-3 always-support-text-exact fst-normal fs-1">How it <span className="always-support-text-exact fst-normal fs-1" style={{ color: "#FA4B1C" }}>Works</span></h1>

          <DonationCart />
        </div>

        <div>
          <div className="text-center fs-1 fw-bold mt-3">You can register as a donor to donate or simply donate as a guest.</div>
          <p className="text-center">
            When you donate, you will be asked to contribute the additional 10% donation to cover CSP costs – which
            is effectively investing in the CSP support community.
          </p>
          <p className="text-center">

            By registering as a donor you will get email updates indicating how your donation is being repaid and
            continuing to be recycled providing more loan opportunities for aspiring entrepreneurs.
            As a registered donor, you also gain access to success stories and enable better communication with the
            Share-Circle, CSPs and entrepreneurs.
          </p>
          <p className="text-center">
            Share-Circle is a registered charity, hence all donations are tax exempt.
          </p>
          <p className="text-center">
            The donation function has credit card, debit card, PayPal and Bitcoin / Lightning payment options.
          </p>
        </div>
        <div>

          {/* <SectionFour/> */}
        </div>

      </div>
      <SectionFour />
    </>
  );
};

export default Donate;
